// import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { PershingError } from '@pershing/pershing-core';
import { MOCK_AGREEMENT_RESPONSE } from './mock-agreement-response';
import { AgreementResponse } from './../models/agreement-response.model';
import { Agreement } from './../models/agreement.model';

@Injectable()
export class MockAgreementService {
    agreementResponse$: Observable<AgreementResponse>;
    error$: Observable<PershingError>;
    private _agreementResponse: BehaviorSubject<AgreementResponse>;
    private _error: BehaviorSubject<PershingError>;
    private dataStore: {
        agreementResponse: AgreementResponse;
    };
    constructor() {
        this._error = new BehaviorSubject<PershingError>(null);
        this.error$ = this._error.asObservable();
        this._agreementResponse = <BehaviorSubject<AgreementResponse>>new BehaviorSubject(null);
        this.agreementResponse$ = this._agreementResponse.asObservable();
        this.dataStore = { agreementResponse: null };
    }
    retrieveAgreement(): void {
        console.log('calling mock retrieve agreement');
        let data = MOCK_AGREEMENT_RESPONSE;
        let agreementResponse: AgreementResponse = new AgreementResponse();
        agreementResponse.response = data.response;
        this.dataStore.agreementResponse = agreementResponse;
        this._agreementResponse.next(Object.assign({}, this.dataStore).agreementResponse);
    }

    updateAgreement(agreement: Agreement): void {
        let data = MOCK_AGREEMENT_RESPONSE;
        let agreementResponse: AgreementResponse = new AgreementResponse();
        agreementResponse.response = data.response;
        this.dataStore.agreementResponse = agreementResponse;
        this._agreementResponse.next(Object.assign({}, this.dataStore).agreementResponse);
    }
}
